import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, OnInit, Output, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterModule } from '@angular/router';
import { Roles } from '@app/common/roles';
import { FeatureToggleModule } from '@app/directives/feature-toggle.directive';
import { BroadcastMessage } from '@app/models/broadcast-message';
import { AppTileBroadcastMessages } from '@app/models/message-broadcast-app-tile';
import { LinkModule } from '@app/directives/link.directive';
import { BroadcastService } from '@app/services/broadcast.service';
import { SecurityService } from '@app/services/security.service';
import { Observable } from 'rxjs';
import { CUSTOMERENVIRONMENT, WINDOW } from '@app/common/app-tokens';
import { Utilities } from '@app/common/utilities';
import { Environment } from '@environments/interface.environment';
import { FormatDateModule } from '@app/pipes/format-date.pipe';

@Component({
  selector: 'app-broadcast-banner-list',
  templateUrl: './broadcast-banner-list.component.html',
  styleUrls: ['./broadcast-banner-list.component.scss']
})
export class BroadcastBannerListComponent implements OnInit {

  @Output() clickOnEditBtnEvent = new EventEmitter<boolean>();
  @Input() broadcastMessages: Array<BroadcastMessage>;
  @Input() appTileBroadcastMessages: Array<AppTileBroadcastMessages>;
  @Input() showHideButton = true;
  @Input() titleTextMaxLength = 77; // title texts gets truncated if longer
  hasPermissionEditorOrAdmin$: Observable<boolean>;

  constructor(private securityService: SecurityService,
              private service: BroadcastService,
              @Inject(CUSTOMERENVIRONMENT) private environment: Environment,
              @Inject(WINDOW) private window: Window) { }

  ngOnInit(): void {
    if (this.appTileBroadcastMessages) {
      this.broadcastMessages = this.appTileBroadcastMessages.map(broadcastMessage => {
        return broadcastMessage.BroadcastMessage;
      });
    }
    this.hasPermissionEditorOrAdmin$ = this.securityService.hasUserAnyAppRole([Roles.Admin, Roles.Editor, Roles.MessageBroadcastEditor]);
  }

  whenEditBtnClicked() {
    Utilities.postMessageToCoreIntranet('edit-broadcast', this.window, this.environment.tenantHostUrl);
    this.clickOnEditBtnEvent.emit(true);
  }

  hide(id: number) {
    this.service.hideBroadcastMessage(id).subscribe();
  }

}

@NgModule({
  declarations: [BroadcastBannerListComponent],
  exports: [BroadcastBannerListComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatExpansionModule,
    MatButtonModule,
    FeatureToggleModule,
    LinkModule,
    FormatDateModule
  ]
})
export class BroadcastBannerListComponentModule { }
